import { render, staticRenderFns } from "./textShadowController.vue?vue&type=template&id=3ddb7b46&"
import script from "./textShadowController.vue?vue&type=script&lang=ts&"
export * from "./textShadowController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports